import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BulkBenchmarkAdd } from './components/bulk-benchmark-add';

type BulkBenchmarkEntryForm = {
    typeId: number | string;
    result: string;
    validationUrl: string;
};

type BulkBenchmarkAddForm = {
    cpuName: string;
    cpuFrequency: string;
    cpuBusFrequency: string;
    cpuVoltage: string;
    cpuTemperature: string;
    cpuIsEngineeringSample: boolean;
    cpuUnlockedCores: string;
    cpuCount: string;
    memorySize: string;
    memoryModules: string;
    memoryFrequency: string;
    memoryTimings: string;
    memoryType: string;
    gpuName: string;
    gpuCount: string;
    motherboardName: string;
    motherboardVendor: string;
    motherboardBios: string;
    osName: string;
    osVersion: string;
    benchmarks: BulkBenchmarkEntryForm[];
};

type SelectOptionRow = {
    value: string;
    label: string;
};

type BulkBenchmarkAddPage = {
    heading: string;
    backUrl: string;
    postUrl: string;
    submitLabel: string;
    cpuLookupUrl: string;
    gpuLookupUrl: string;
    antiForgeryToken: string;
    errorMessage?: string | null;
    benchmarkTypes: SelectOptionRow[];
    form: BulkBenchmarkAddForm;
};

function initializeBulkBenchmarkAdd(): void {
    const rootElement = document.getElementById('bulk-benchmark-add-root');
    if (!(rootElement instanceof HTMLElement)) {
        return;
    }

    const pageData = rootElement.dataset.page;
    if (typeof pageData !== 'string' || pageData.length === 0) {
        return;
    }

    const page = JSON.parse(pageData) as BulkBenchmarkAddPage;
    createRoot(rootElement).render(<BulkBenchmarkAdd page={page} />);
}

initializeBulkBenchmarkAdd();
